export const registrationFields = {
  username: '',
  password: '',
  repeatPassword: '',
  mobileNumber: '',
  digitPhone: '',
  phone: '',
}

export const phoneMaskUtils = {
  code: '+54',
  mask: '(__) ____-____',
  maxLength: 11,
}

export const documentMaskUtils = {
  mask: '___.___.___-__',
  maxLength: 11,
}
